import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { images } from "../../Images/Svg";
import { useLocation, useNavigate } from "react-router-dom";
import style from "./CaseSearch.module.css";
import TableComponent from "../../CommonComponents/Table";
import { useDispatch, useSelector } from "react-redux";
import { CaseSearchViewData } from "../../constants/caseSearchData";
import MuiTab from "../../CommonComponents/Tab/MuiTab";
import {
  storeCaseId,
  storeIsAllocatedCase,
} from "../../Redux/Slice/CaseManagementActionsSlice/CaseDescriptionSlice";
import {
  allocatedCaseActionList,
  approvalActionList,
  defaultCaseActionList,
  motorTriggerTable,
  openCaseActionList,
  options,
  qcCaseActionList,
  queryCaseActionList,
  recommendedCaseActionList,
  rejectedCaseActionList,
  segmentInfoDetails,
  submittedCaseActionList,
} from "../../constants/utils";
import RaiseQueryModal from "../CaseManagement/Actions/RaiseQueryModal";
import DragDrop from "../../CommonComponents/DragDrop/DragDrop";
import UploadDocument from "../CaseManagement/Actions/UploadDoucument/UploadDocument";
import GradeCaseModal from "../CaseManagement/Actions/GradeCase";
import Approval from "../CaseManagement/Actions/Approval";
import VendorAssesment from "../CaseManagement/Actions/AssesmentCalculator";
import Reject from "../CaseManagement/Actions/Reject";
import CaseDescription from "../CaseManagement/Actions/CaseDescription/CaseDescription";
import {
  disableSecondTabVal,
  dropDownOptions,
  tabs2CaseManagement,
  tabs2CaseManagementRecommended,
  tabs2CaseManagementSubmitted,
  tabs2CaseManagementVendor,
} from "../../constants/caseManagementData";
import { Box } from "@mui/system";
import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import TableGridSkeleton from "../../CommonComponents/TableGridSkeleton";
import ExternalInformation from "../../CommonComponents/ExternalInformation";
import RecommendationTabelGrid from "../../CommonComponents/TableGridView/RecommendationTabelGrid";
import CommonDescription from "../../CommonComponents/CommonDescription";
import useToaster from "../../customHook/useToaster";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";
import { getRlmuData } from "../../Services/de-empanel.service";
import {
  approvalFlagPutApi,
  getDeEmpanelSegmentInfo,
} from "../../Services/approval.service";
import {
  caseDescriptionPut,
  getAllCasesSegmentInfo,
  holdUnholdApi,
  vendorDetailInfoOFAllocated,
  withdrawalCase,
} from "../../Services/caseManagement.service";
import { debounce } from "lodash";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import { tabs2Approval } from "../../constants/approvalsData";
import Investigation from "../Approval/Investigation/Investigation";
import { Typography } from "@mui/material";
import TableSkeleton from "../../CommonComponents/TableSkeleton";
import ReassignCase from "../CaseManagement/Actions/ReassignCase";
import PeerReview from "../CaseManagement/Actions/PeerReview/PeerReview";
import { caseManagementMenuReducer } from "../../Redux/Slice/CaseManagementMenuSlice";
import { tabReducer } from "../../Redux/Slice/SideBarSlice";
import PromptModal from "../../CommonComponents/PromptModal/PromptModal";
import { caseSearchDataReducer } from "../../Redux/Slice/CaseSearchSlice/caseSearchSlice";
import ReasonModal from "../../CommonComponents/Modal/ReasonModal";
import { getCimaCaseDetails } from "../../Services/caseSearch.service";

const { backArrowBold } = images;

const gridViewTabs = [
  "Basic Details",
  "Policy Details",
  "Proposal Details",
  "Risk Details",
];

const firstIndexMapping = {
  open: 0,
  allocated: 1,
  qc: 2,
  recommended: 3,
  submitted: 4,
  rejected: 5,
  "case approval": 0,
  closed: 0,
};

function CaseSearchView() {
  const navigate = useNavigate();
  const onBackClick = (e) => {
    navigate(-1);
    dispatch(caseSearchDataReducer(""));
  };
  const selectedCaseId = useRef(0);
  const dispatch = useDispatch();
  const { searchDetails, searchValue, searchSource } = useSelector(
    (state) => state.SearchSlice
  );
  const userRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );
  const { caseId, lobName } = useSelector(
    (state) => state?.CaseDescriptionSlice
  );
  const [actionTabState, setActionTabState] = useState([]);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [actionModalType, setActionModalType] = useState("");
  const [displaySecondTab, setDisplaySecondTab] = useState(false);
  const [secondTabVal, setSecondTabVal] = useState("Basic Details");
  const [activeCaseId, setActiveCaseId] = useState(0);
  const [investigationsActiveTabValue, setInvestigationActiveTabValue] =
    useState(-1);
  const [vendorBlockisClicked, setVendorBlockIsClicked] = useState(false);
  const [isVendorClicked, setIsVendorClicked] = useState(false);
  const [openCollapse, setOpenCollapse] = useState();
  const [selectedCollapseId, setSelectedCollapseId] = useState(0);
  const [caseManagementSegmentInfoState, setCaseManagementSegmentInfoState] =
    useState({});
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [secondTabIndex, setSecondTabIndex] = useState(0);
  const [tableCollapseDataState, setTableCollapseDataState] = useState([]);
  const [recommendationData, setRecommendationData] = useState(null);
  const [recommendationName, setRecommendationName] = useState("");
  const [caseManagementDataState, setCaseManagementDataState] = useState([]);
  const [rlmuData, setRlmuData] = useState([]);
  const [AllCasesCount, setAllCasesCount] = useState([]);
  const [rerenderSegmentApiState, setRerenderSegmentApiState] = useState(false);
  const [storeFilterData, setStoreFilterData] = useState([]);
  const [rerenderSearchCaseList, setRerenderSearchCaseList] = useState(false);
  const [reAssignModal, setReAssignModal] = useState(false);
  const [vendorDetailIndexNumber, setVendorDetailIndexNumber] = useState(-1);
  const [withdrawAllocationId, setWithdrawAllocationId] = useState("");
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [isHoldCase, setIsHoldCase] = useState();
  const [claimNumber, setClaimNumber] = useState("");
  const viewTableRef = useRef(null);
  const actionPopperRef = useRef(null);
  const descriptionRef = useRef("");
  const { showToast } = useToaster();
  const viewCaseId = useSelector((state) => state?.caseSearchSlice?.caseId);
  const caseSearchData = useSelector(
    (state) => state?.SearchSlice?.searchDetails?.caseList
  );
  const tabStatus = useSelector((state) => state?.caseSearchSlice?.caseStatus);
  let firstTabVal = tabStatus?.charAt(0)?.toUpperCase() + tabStatus?.slice(1);
  if (firstTabVal === "Review") firstTabVal = "Case Approval";
  const tabName = [{ label: firstTabVal }];
  const location = useLocation();
  const isAssigned = location.state?.isAssigned;
  const { isAllocatedCase } = useSelector(
    (state) => state?.CaseDescriptionSlice
  );

  // const firstTabVal = [
  //   "open",
  //   "allocated",
  //   "qc",
  //   "recommended",
  //   "submitted",
  //   "rejected",
  // ];
  const flagApiFun = async () => {
    try {
      const data = await approvalFlagPutApi(selectedCaseId.current, {
        star: true,
      });
      if (data.success) {
        showToast("Case flagged", "success", true);
        // setRerenderApprovalCaseList((prev) => !prev);
      } else {
        showToast("Error in case flagged", "error", true);
      }
    } catch (error) {
      showToast("Error In Flaging case", "error", true);
    }
  };

  const holdUnholdApiCall = useCallback(
    (caseId, isHold, selectedValue, remark) => {
      let payload = {
        hold_status: isHold ? "unhold" : "hold",
        hold_reason: !isHold ? selectedValue : "",
        remarks: !isHold ? remark : "",
      };
      dispatch(isLoadingStateReducer(true));
      holdUnholdApi(caseId, payload)
        ?.then((response) => {
          if (response?.success) {
            setReRender(true);
            showToast(response?.message, "success", true);
          }
          dispatch(isLoadingStateReducer(false));
          onBackClick();
        })
        ?.catch((err) => {
          dispatch(isLoadingStateReducer(false));
          console.log(err);
          showToast(
            err?.response?.data?.message || "Something went wrong",
            "error",
            true
          );
        });
    },
    []
  );

  const onClickFirstPopper = useCallback(
    async (e, type, SrNo, caseId, isHold) => {
      setActiveCaseId(selectedCaseId?.current);
      setIsHoldCase(isHold);
      if (type === "view") {
        setInvestigationActiveTabValue(-1);
        setVendorBlockIsClicked(false);
        setIsVendorClicked(false);
        if (displaySecondTab) {
          setDisplaySecondTab(false);
          setTimeout(() => {
            setDisplaySecondTab(true);
          }, 50);
        } else {
          setDisplaySecondTab(true);
        }
        if (firstTabVal === "Allocated") setSecondTabVal("Vendor Details");
        else if (firstTabVal === "Case Approval")
          setSecondTabVal("Investigation");
        else setSecondTabVal("Basic Details");
        if (firstTabVal === "Closed") setSecondTabVal("Investigation");
        setSecondTabIndex(0);
        setRerenderSegmentApiState((prev) => !prev);
        setTimeout(() => {
          viewTableRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }, 100);
      } else {
        if (type === "Re-open") {
          // showToast("Coming soon", "info", true);
          return;
        }
        if (type === "Assign Block") {
          navigate("/assignBlock");
          return;
        }
        if (type === "Hold / Unhold" && isHold) {
          holdUnholdApiCall(caseId, isHold);
          return;
        }
        if (type === "Flag") {
          await flagApiFun();
        } else {
          setOpenActionModal(true);
          setActionModalType(type);
          actionPopperRef.current = {
            caseId: selectedCaseId?.current,
            open: true,
          };
        }
      }
    },
    [displaySecondTab, firstTabVal]
  );

  const dropDownSubmitHandler = (selectedValue, remark) => {
    if (selectedValue && remark) {
      holdUnholdApiCall(caseId, isHoldCase, selectedValue, remark);
      setOpenActionModal(false);
      setReRender(true);
    } else {
      showToast("Please fill all the input fields.", "error", true);
    }
  };

  const ActionTabContent = useCallback((firstTabVal) => {
    switch (firstTabVal) {
      case "Open":
        let filteredActions = openCaseActionList;
        if (userRole === "RM" || userRole === "NM" || userRole === "NH") {
          filteredActions = filteredActions.filter(
            (item) => item.label === "Hold / Unhold"
          );
        }
        if (userRole === "QC") {
          filteredActions = filteredActions.filter(
            (item) => item.label !== "Assign Block"
          );
        }
        setActionTabState(filteredActions);
        break;
      case "Allocated":
        setActionTabState(allocatedCaseActionList);
        break;
      case "QC":
        setActionTabState(qcCaseActionList);
        break;
      case "Query":
        setActionTabState(queryCaseActionList);
        break;
      case "Recommended":
        setActionTabState(recommendedCaseActionList);
        break;
      case "Submitted":
        setActionTabState(submittedCaseActionList);
        break;
      case "Rejected":
        setActionTabState(rejectedCaseActionList);
        break;
      case "Case Approval":
        setActionTabState(approvalActionList);
        break;
      default:
        setActionTabState(defaultCaseActionList);
    }
  }, []);

  const onCellClicked = useCallback(
    (e, colId, colValue, lobName, index, isHold) => {
      if (typeof colValue === "number") {
        selectedCaseId.current = colValue;
        dispatch(storeCaseId({ colValue, lobName }));
      }
      if (secondTabVal === "Vendor Details") {
        if (colValue === "View Blocks") {
          setCaseManagementSegmentInfoState((prev) => {
            if (prev.length) {
              let newArr = [...prev];
              newArr = newArr.map((item, mapIndex) => {
                if (mapIndex === index) item.view_blocks = "Hide Blocks";
                else item.view_blocks = "View Blocks";
                return item;
              });
              return newArr;
            } else {
              return prev;
            }
          });
          setOpenCollapse(index);
        } else if (colValue === "Hide Blocks") {
          setCaseManagementSegmentInfoState((prev) => {
            if (prev.length) {
              let newArr = [...prev];
              newArr[index].view_blocks = "View Blocks";
              return newArr;
            } else {
              return prev;
            }
          });
          setOpenCollapse((prev) => false);
        } else {
          setOpenCollapse((prev) => false);
        }
        if (colValue === "Re-assign") {
          setReAssignModal(true);
          setVendorDetailIndexNumber(index + 1);
        }
        if (colValue === "Withdraw") {
          setWithdrawModal(true);
          setWithdrawAllocationId(
            caseManagementSegmentInfoState[index]?.caseAllocationId
          );
        }
      }
      if (searchSource === "Cima") {
        setClaimNumber(caseSearchData?.[index]?.claim_no);
      }
      setSelectedCollapseId(index);
    },
    [secondTabVal, searchSource, caseManagementSegmentInfoState, caseSearchData]
  );
  //set toggle for render
  const toggleRender = useCallback(() => {
    setReRender((prev) => !prev);
  }, []);
  const onAssignBlockHandler = useCallback(() => {
    setOpenActionModal(false);
    toggleRender();
  }, [toggleRender]);

  const withdrawalCaseFunc = useCallback(
    (caseid, withdrawReason) => {
      let data = {
        caseId: caseid,
        caseAllocationIds: [withdrawAllocationId],
        withdrawalReason: withdrawReason,
      };
      setWithdrawModal(false);
      dispatch(isLoadingStateReducer(true));
      withdrawalCase(data)
        .then((res) => {
          if (res?.success) {
            dispatch(isLoadingStateReducer(false));
            navigate(-1);
            showToast(res?.message, "success", true);
          }
        })
        .catch((err) => {
          dispatch(isLoadingStateReducer(false));
          showToast(err?.response?.data?.message, "error", true);
        });
    },
    [withdrawAllocationId]
  );

  const actionFactory = useCallback(
    (x) => {
      let component = null;
      switch (x) {
        case "Raise Query":
          component = <RaiseQueryModal />;
          break;
        case "Assign Block":
          component = (
            <DragDrop
              // data={assignBlock}
              label={"Assign Block"}
              // blockCount={`Blocks to be assigned: ${assignBlock?.length}`}
              options={options}
              // handelChange={(e) => setDropDownValue(e.target.value)}
              // valueOfDropDown={dropDownValue}
              onAssign={onAssignBlockHandler}
            />
          );
          break;
        case "Re-Assign":
          component = (
            <ReassignCase
              onSuccess={() => {
                setOpenActionModal(false);
              }}
            />
          );
          break;
        case "Upload Documents":
          component = (
            <UploadDocument onSuccess={() => setOpenActionModal(false)} />
          );
          break;
        case "Grade Case":
          component = (
            <GradeCaseModal setOpenActionModal={setOpenActionModal} />
          );
          break;
        case "Submit Final":
          component = (
            <Approval
              message="Do you have any recommendations?"
              onClick={(value) => {
                setOpenActionModal(value);
                setReRender(true);
                dispatch(
                  caseManagementMenuReducer({
                    caseManagementMenuTab: "Submitted",
                    caseManagementMenuTabIndex:
                      userRole === "QC" && 4 > 1 ? 4 - 1 : 4,
                  })
                );
                dispatch(tabReducer("CaseManagementTab"));
                navigate("/caseManagement");
              }}
              isSubmit={true}
            />
          );
          break;
        case "Approve":
          component = <Approval />;
          break;
        case "Vendor Assessment":
          component = <VendorAssesment caseId={caseId} />;
          break;
        case "Reject":
          component = (
            <Reject
              // onSubmit={onRejectSubmitClick}
              setOpenActionModal={setOpenActionModal}
            />
          );
          break;
        case "Case Description":
          component = (
            <CaseDescription onSubmit={() => setOpenActionModal(false)} />
          );
          break;
        case "Case History":
          component = <CaseDescription />;
          break;
        case "Peer Review":
          component = (
            <PeerReview
              caseId={caseId}
              onSuccess={() => setOpenActionModal(false)}
            />
          );
          break;
        case "Hold / Unhold":
          if (!isHoldCase) {
            component = (
              <ReasonModal
                reasons={dropDownOptions}
                submitHandler={(selectValue, remark) => {
                  dropDownSubmitHandler(selectValue, remark);
                }}
              />
            );
          }
          break;
        default:
          return "Failed to load";
      }
      return component;
    },
    [onAssignBlockHandler]
  );

  const secondTabChangeClickHandler = useCallback((event, newValue) => {
    setSecondTabVal(event.target.innerText);
    setSecondTabIndex(newValue);
    setSelectedCollapseId(null);
    setOpenCollapse(false);
  }, []);
  const onSubmitButton = async (event, newValue) => {
    try {
      const data = await caseDescriptionPut(
        secondTabVal === "CHASE Smart"
          ? "External"
          : secondTabVal.split(" ")[0],
        {
          caseId,
          description: descriptionRef?.current?.value || "",
        }
      );
      if (data?.success) {
        showToast(data?.message, "success", true);
      } else {
        showToast(
          data?.message || "Error in updating description",
          "error",
          true
        );
      }
    } catch (error) {
      showToast(
        error.response.data.message || "Error in updating description",
        "error",
        true
      );
    }
  };

  const secondPopperListItem = useMemo(() => {
    return isAssigned ? actionTabState : [];
  }, [isAssigned, actionTabState]);

  const getAllCasesSegmentInfoFun = useCallback(
    async (secondTabVal, claimNumber) => {
      try {
        if (secondTabVal === "Vendor Details") {
          const { data } = await vendorDetailInfoOFAllocated({
            caseId: selectedCaseId.current,
          });
          const venderDetailSegmentInfoData =
            data?.assignedToInvestigatorsWithInvestigationStatus.map(
              (item, i, arr) => {
                if (item?.investigationStatus === "pending") {
                  item.investigationStatus = "Pending";
                } else if (item?.investigationStatus === "completed") {
                  item.investigationStatus = "Approved";
                } else if (item?.investigationStatus === "rejected") {
                  item.investigationStatus = "Rejected";
                } else if (item?.investigatorDetails?.reassigned_to) {
                  item.investigatorDetails.reassigned_to = "Reassigned";
                } else if (item?.investigationStatus === "review") {
                  item.investigationStatus = item.investigatorDetails
                    .reassigned_to
                    ? "Reassigned"
                    : "Review";
                }
                arr[i] = {
                  vendor_names: item?.investigatorDetails?.vendor_name,
                  case_status:
                    item.investigatorDetails.reassigned_to ||
                    item?.investigationStatus,
                  view_blocks: "View Blocks",
                  re_assign:
                    item.investigatorDetails.reassigned_to !== "Reassigned"
                      ? "Re-assign"
                      : undefined,
                  withdraw:
                    item?.investigationStatus !== "Review" &&
                    item.investigatorDetails.reassigned_to !== "Reassigned"
                      ? "Withdraw"
                      : undefined,
                  mobile_number: item?.investigatorDetails?.mobile_number,
                  location: item?.investigatorDetails?.city,
                  email: item?.investigatorDetails?.email,
                  blocksAssigned: item?.investigatorDetails?.blocksAssigned,
                  caseAllocationId:
                    item?.investigatorDetails?.case_allocation_id,
                  srNo: i + 1,
                };
                return arr[i];
              }
            );
          setCaseManagementSegmentInfoState(venderDetailSegmentInfoData);
        } else if (secondTabVal && secondTabVal === "FCU Actions") {
          getRlmuData(selectedCaseId?.current)
            .then((res) => {
              if (res?.success) {
                setRlmuData(res?.data);
              }
            })
            .catch((error) => showToast(error?.message, "error", true));
        } else if (secondTabVal === "Recommendation") {
          getDeEmpanelSegmentInfo(activeCaseId, recommendationName)
            .then((res) => {
              if (res?.success) {
                setRecommendationData(res?.data);
              }
            })
            .catch((err) => {
              dispatch(isLoadingStateReducer(false));
              showToast(err?.message, "error", true);
            });
        } else if (
          secondTabVal !== "Investigation" &&
          searchSource !== "Cima"
        ) {
          // dispatch(isLoadingStateReducer(true));
          const data = await getAllCasesSegmentInfo(
            secondTabVal === "CHASE Smart"
              ? "External"
              : secondTabVal.split(" ")[0],
            {
              caseId: selectedCaseId.current,
            }
          );
          if (data?.success) {
            setShowSkeleton(true);
            let caseManagementSegmentInfoData = data?.data;
            if (secondTabVal === "Claim Details") {
              let documentsData = data?.data?.publicUrls;
              caseManagementSegmentInfoData = data.data.claimResult.map(
                (item, i, arr) => {
                  arr[i] = {
                    ...arr[i],
                    view_details: "View Details",
                    create_case: "Create Case",
                    documents: documentsData,
                    srNo: i + 1,
                  };
                  return arr[i];
                }
              );
            } else if (secondTabVal === "Risk Details") {
              caseManagementSegmentInfoData.triggers =
                caseManagementSegmentInfoData?.trigger?.map((item, index) => ({
                  ...item,
                  srNo: index + 1,
                })) || [];
            } else if (
              secondTabVal === "Dispatch Details" ||
              secondTabVal === "Endorsement Details"
            ) {
              caseManagementSegmentInfoData = data.data.map((item, i, arr) => {
                arr[i] = {
                  ...arr[i],
                  view_details: "View Details",
                  srNo: i + 1,
                };
                return arr[i];
              });
            }
            if (caseManagementSegmentInfoData?.policy_status) {
              if (caseManagementSegmentInfoData?.policy_status === true) {
                caseManagementSegmentInfoData.policy_status = "Active";
              } else if (
                caseManagementSegmentInfoData?.policy_status === false
              ) {
                caseManagementSegmentInfoData.policy_status = "In Active";
              }
            }
            setCaseManagementSegmentInfoState(caseManagementSegmentInfoData);
            if (
              caseManagementSegmentInfoData?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData?.case_description;
            } else if (
              caseManagementSegmentInfoData[0] &&
              caseManagementSegmentInfoData[0]?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData[0].case_description;
            } else if (descriptionRef.current) {
              descriptionRef.current.value = "";
            }
          }
          dispatch(isLoadingStateReducer(false));
        }
        if (searchSource === "Cima") {
          const data = await getCimaCaseDetails(secondTabVal.split(" ")[0], {
            claim_no: claimNumber,
          });
          if (data?.success) {
            setShowSkeleton(true);
            let caseManagementSegmentInfoData = data?.data;
            if (secondTabVal === "Claim Details") {
              // let documentsData = data?.data?.publicUrls;
              caseManagementSegmentInfoData = data.data.claimResult.map(
                (item, i, arr) => {
                  arr[i] = {
                    ...arr[i],
                    view_details: "View Details",
                    // create_case: "Create Case",
                    // documents: documentsData,
                    srNo: i + 1,
                  };
                  return arr[i];
                }
              );
              setCaseManagementSegmentInfoState(caseManagementSegmentInfoData);
            } else {
              setCaseManagementSegmentInfoState(caseManagementSegmentInfoData);
            }
            dispatch(isLoadingStateReducer(false));
          }
        }
      } catch (error) {
        setCaseManagementSegmentInfoState({});
        dispatch(isLoadingStateReducer(false));
        showToast(
          error?.response?.data?.message || "Error In Fetching Segment Info",
          "error",
          true
        );
      }
    },
    [activeCaseId, recommendationName, searchSource]
  );
  const debounceSegmentsApiCall = useCallback(
    debounce(getAllCasesSegmentInfoFun, 350),
    []
  );
  const renderActionComponent = useCallback(() => {
    return actionFactory(actionModalType);
  }, [actionFactory, actionModalType]);
  useEffect(() => {
    if (displaySecondTab) {
      debounceSegmentsApiCall(secondTabVal, claimNumber);
    }
  }, [secondTabVal, displaySecondTab, rerenderSegmentApiState, claimNumber]);
  useEffect(() => {
    if (userRole === "IM" || userRole === "QC") {
      ActionTabContent(firstTabVal);
    } else {
      setActionTabState([]);
    }
  }, [userRole]);

  useEffect(() => {
    setShowSkeleton(false);
  }, [secondTabVal]);

  useEffect(() => {
    const filtereddata = caseSearchData?.filter(
      (item) => viewCaseId === item?.case_id
    );
    setStoreFilterData(filtereddata);
  }, [viewCaseId]);

  useEffect(() => {
    if (secondTabVal === "Vendor Details") {
      setTableCollapseDataState(
        caseManagementSegmentInfoState[selectedCollapseId]
      );
    } else if (caseManagementSegmentInfoState[selectedCollapseId]) {
      let columnData = [];
      if (firstTabVal === "Case Approval") {
        columnData = segmentInfoDetails?.[secondTabVal]?.column?.map(
          (item) => item.id
        );
      } else {
        columnData = segmentInfoDetails?.[secondTabVal]?.column?.map(
          (item) => item.id
        );
      }

      const tableCollapseData = Object.keys(
        caseManagementSegmentInfoState[selectedCollapseId]
      )?.filter((item) => !columnData?.includes(item));

      const tableCollapseDataObj = {};
      tableCollapseData?.forEach((item) => {
        tableCollapseDataObj[item] =
          caseManagementSegmentInfoState[selectedCollapseId][item];
      });

      setTableCollapseDataState(tableCollapseDataObj);
    }
  }, [secondTabIndex, caseManagementSegmentInfoState, selectedCollapseId]);

  useEffect(() => {
    if (secondTabVal === "Investigation") {
      setInvestigationActiveTabValue(-1);
    }
  }, [secondTabVal]);

  return (
    <div className={style["case_search_Container"]}>
      <div className={style["case_search_header_container"]}>
        <img
          height="20"
          className={style["backArrow_Image"]}
          src={backArrowBold}
          alt="backArrow"
          onClick={onBackClick}
        />
        <h1
          className={style["case_search_header"]}
          style={{ fontSize: "1.4rem", color: "#737D8C" }}
        >
          Search result for {searchValue}
        </h1>
      </div>

      {isAssigned ? <MuiTab tabs={tabName} activeTab={0} /> : null}
      <div style={{ marginTop: "1rem", marginLeft: "1.8rem" }}>
        <TableComponent
          stickyHeader={false}
          columnHeaderBackgroundColor={"#FCF7FF"}
          columnHeaderColor={"#242424"}
          columnHeaderFontWeight={600}
          columnBodyFontWeight={400}
          rowsData={storeFilterData}
          columnsData={
            CaseSearchViewData?.[0]?.column?.[
              tabName?.[0]?.label?.toLowerCase()
            ]
          }
          activeMenu="caseManagement"
          popperContentMatch={"case_id"}
          hideBorders={true}
          tablePagination={false}
          onClickFirstPopper={onClickFirstPopper}
          onCellClicked={onCellClicked}
          secondPopperListItem={secondPopperListItem}
          firstTabVal={firstTabVal}
          // flagToHideView={searchSource === "Cima"}
          // flagToViewAction={"true"}
          // secondPopperListItem={[]}
        />
      </div>
      <CommonModal
        label={
          actionModalType === "Assign Block"
            ? "Assign Block"
            : actionModalType === "Case Description"
            ? "Case Description"
            : ""
        }
        open={openActionModal}
        showCrossIcon={true}
        width={
          actionModalType === "Upload Documents"
            ? "52rem"
            : actionModalType === "Assign Block"
            ? "60%"
            : actionModalType === "Raise Query"
            ? "30%"
            : actionModalType === "Case Description" ||
              actionModalType === "Case History"
            ? "60%"
            : actionModalType === "Vendor Assessment"
            ? "45%"
            : "30%" // default
        }
        height={
          actionModalType === "Assign Block"
            ? "75%"
            : actionModalType === "Grade Case"
            ? "45rem"
            : "none"
        }
        onClose={() => setOpenActionModal(false)}
      >
        {renderActionComponent()}
      </CommonModal>
      {displaySecondTab ? (
        <>
          <MuiTab
            tabs={
              firstTabVal === "Allocated"
                ? tabs2CaseManagementVendor
                : firstTabVal === "Recommended"
                ? tabs2CaseManagementRecommended
                : firstTabVal === "Submitted" ||
                  firstTabVal === "QC" ||
                  firstTabVal === "Rejected"
                ? tabs2CaseManagementSubmitted
                : firstTabVal === "Case Approval" || firstTabVal === "Closed"
                ? tabs2Approval[firstIndexMapping?.[firstTabVal?.toLowerCase()]]
                    ?.headerVal
                : tabs2CaseManagement
            }
            variant="standard"
            onClick={secondTabChangeClickHandler}
            ref={viewTableRef}
            id={secondTabVal}
          />
          <Box sx={{ marginTop: "10px" }}>
            {gridViewTabs?.includes(secondTabVal) ? (
              Object.keys(caseManagementSegmentInfoState).length &&
              showSkeleton ? (
                <TableGrid
                  gridContent={
                    caseManagementSegmentInfoState[0]
                      ? caseManagementSegmentInfoState[0]
                      : caseManagementSegmentInfoState
                  }
                  isDocument={
                    caseManagementSegmentInfoState?.documents?.length
                      ? true
                      : false
                  }
                  backgroundColor="#FFFFFF"
                  boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                  documentDetails={caseManagementSegmentInfoState?.documents}
                />
              ) : (
                <TableGridSkeleton />
              )
            ) : secondTabVal === "Investigation" ? (
              <Investigation
                caseId={selectedCaseId?.current}
                investigationsActiveTabValue={investigationsActiveTabValue}
                setInvestigationActiveTabValue={setInvestigationActiveTabValue}
                setVendorBlockIsClicked={setVendorBlockIsClicked}
                vendorBlockisClicked={vendorBlockisClicked}
                setIsVendorClicked={setIsVendorClicked}
                isVendorClicked={isVendorClicked}
                firstTabIndex={firstIndexMapping?.[firstTabVal?.toLowerCase()]}
                secondTabIndex={secondTabIndex}
                tabStatus={tabStatus}
                setRerenderApprovalCaseList={() =>
                  setRerenderSearchCaseList((prev) => !prev)
                }
                isAssignedToCurrentUser={isAssigned}
              />
            ) : secondTabVal === "CHASE Smart" ? (
              Object.keys(caseManagementSegmentInfoState).length &&
              showSkeleton ? (
                <ExternalInformation
                  backgroundColor="#FFFFFF"
                  boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                  data={caseManagementSegmentInfoState}
                  documentDetails={
                    segmentInfoDetails?.[secondTabVal]?.documentDetails
                  }
                />
              ) : (
                <TableGridSkeleton showProfileSkeleton />
              )
            ) : secondTabVal === "Vendor Details" ? (
              <>
                <div
                  style={{
                    boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
                  }}
                >
                  <TableComponent
                    rowsData={caseManagementSegmentInfoState}
                    columnsData={
                      userRole === "IM"
                        ? segmentInfoDetails?.[secondTabVal]?.column
                        : segmentInfoDetails?.[secondTabVal]?.column.filter(
                            (column) => column.id !== "withdraw"
                          )
                    }
                    hideColumnWithId={userRole !== "IM" ? "re_assign" : null}
                    TableCollapseContent={tableCollapseDataState}
                    onCellClicked={onCellClicked}
                    open={openCollapse}
                    setOpen={setOpenCollapse}
                    vendorDetailsTab={true}
                    TableCollapseContentDocument={false}
                    tablePagination={false}
                    paddingLeftHeaderStyledTableCell="3px"
                    paddingHeaderStyledTableCell="10.5px"
                    paddingBodyStyledTableCell="15.5px"
                    paddingLeftBodyStyledTableCell="5px"
                    columnHeaderColor={"#666666"}
                    columnHeaderFont="1.1rem"
                    columnHeaderFontWeight={400}
                    columnBodyColor={"#3A3A3A"}
                    columnBodyFont="1.2rem"
                    columnBodyFontWeight={500}
                    paddingBody=".5rem"
                    paddingHeader=".75rem"
                    tablePadding="0rem"
                    vendorDetailPadding="16px 32px"
                    vendorDetailBorderRadius="4px"
                    vendorDetailBorder="1px solid #E8E8E8"
                    isCheckbox={false}
                  />
                </div>
                <CommonModal
                  label="Re-assign Case"
                  open={reAssignModal}
                  onClose={() => {
                    setReAssignModal(false);
                  }}
                  width="42.1rem"
                  height="28rem"
                >
                  <Approval
                    message=""
                    isReassign={true}
                    onReassignClick={(type) => {
                      dispatch(storeIsAllocatedCase(true));
                      navigate(`/re-assign/${vendorDetailIndexNumber}/${type}`);
                    }}
                  />
                </CommonModal>
                <CommonModal
                  open={withdrawModal}
                  onClose={() => setWithdrawModal(false)}
                  showCrossIcon
                >
                  <PromptModal
                    title="Are you sure you want to Withdraw the case ?"
                    submitHandler={(inputValue) => {
                      if (inputValue?.trim().length) {
                        withdrawalCaseFunc(caseId, inputValue);
                      } else {
                        showToast("Please fill the remark", "error", true);
                      }
                    }}
                    handleNoClick={() => setWithdrawModal(false)}
                  />
                </CommonModal>
              </>
            ) : secondTabVal === "Recommendation" ? (
              <RecommendationTabelGrid
                gridContent={recommendationData || {}}
                secondTabVal={secondTabVal}
                firstTabVal={
                  recommendationName?.charAt(0)?.toUpperCase() +
                  recommendationName?.slice(1)
                }
                selectedCaseData={caseManagementDataState?.find(
                  (obj) => obj?.case_id == selectedCaseId?.current
                )}
              />
            ) : secondTabVal === "FCU Actions" ? (
              <RecommendationTabelGrid
                selectedCaseData={caseManagementDataState?.find(
                  (obj) => obj?.case_id == activeCaseId
                )}
                gridContent={{ rlmu: rlmuData }}
                firstTabVal={firstTabVal?.split(" ")[0]}
                secondTabVal={secondTabVal}
              />
            ) : Object.keys(caseManagementSegmentInfoState).length &&
              showSkeleton ? (
              <TableComponent
                rowsData={caseManagementSegmentInfoState}
                columnsData={segmentInfoDetails?.[secondTabVal]?.column}
                hideColumnWithId={userRole !== "IM" ? "create_case" : null}
                TableCollapseContent={tableCollapseDataState}
                onCellClicked={onCellClicked}
                open={openCollapse}
                setOpen={setOpenCollapse}
                TableCollapseContentDocument={false}
                tablePagination={false}
                hideBorders={true}
                paddingLeftHeaderStyledTableCell="3px"
                paddingHeaderStyledTableCell="4.5px"
                paddingBodyStyledTableCell="4.5px"
                columnHeaderColor={"#E42125"}
                columnHeaderFont="1.2rem"
                columnHeaderFontWeight={600}
                columnBodyFont="1.2rem"
                columnBodyFontWeight={500}
                paddingBody=".5rem"
                paddingHeader=".75rem"
                tableBoxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                tableBorder={""}
                tablePadding="1.5rem 0rem"
                createCaseClickHandler={() => navigate("/createCase")}
              />
            ) : (
              <TableGridSkeleton />
            )}

            {secondTabVal === "Risk Details" && (
              <Box>
                <Typography
                  sx={{
                    font: "Inter",
                    fontWeight: 500,
                    fontSize: "1.4rem",
                    color: "#505050",
                    margin: "15px 0 10px 0",
                  }}
                >
                  {lobName?.toLowerCase() === "motor"
                    ? "Motor Trigger"
                    : "Health Trigger"}
                </Typography>
                {Object.keys(caseManagementSegmentInfoState)?.length &&
                showSkeleton ? (
                  <TableComponent
                    stickyHeader={false}
                    columnHeaderBackgroundColor={"#FFDFCB"}
                    columnHeaderColor={"#242424"}
                    columnHeaderFontWeight={600}
                    columnBodyFontWeight={400}
                    rowsData={caseManagementSegmentInfoState?.triggers || []}
                    columnsData={motorTriggerTable?.column}
                    hideBorders={true}
                    tablePagination={false}
                    isNoDataRow={true}
                  />
                ) : (
                  <TableSkeleton rows={1} pagination={false} />
                )}
              </Box>
            )}

            {secondTabVal !== "Vendor Details" &&
              secondTabVal !== "Investigation" &&
              secondTabVal !== "FCU Actions" && (
                <CommonDescription
                  onSubmitButton={onSubmitButton}
                  descriptionRef={descriptionRef}
                />
              )}
          </Box>
        </>
      ) : null}
    </div>
  );
}

export default CaseSearchView;
